import {Component, Inject, OnInit} from '@angular/core';

import {SafeHtml} from '@angular/platform-browser';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {Recrute, TransitionEnum} from '../../../common/services';
import {RecruteFormModel} from '../../common/recrute/recrute-form.model';
import {DateHelperService} from 'app/dar/common/services/date-helper/date-helper.service';
import {RecruteValidationDataModel} from './recrute-validation-data.model';
import {DataTransitionValidationModel} from '../data-transition-validation.model';
import {DarDossiersService} from '../../../common/services/dossiers/dossiers.service';

/**
 * Component de validation d'étape en modale
 *
 *     L'INM recrutement est obligatoire si rémunération indiciaire, optionnel si horaire à partir de SPTA -- sans publication : recruté ---> SPTA traitement ou SPTA ---- Publication : recruté ----> SPTA traitement
 *     Optionnellement il peut saisir le recruté ainsi que le gestionnaire SPTA
 *
 * Je précise que je ne suis pas forcément fier de ce code concernant la gestion du recruté, conséquence d'ajouts de dernières minutes, bref à refactorer un jour :)
 */
@Component({
  selector: 'app-validation-button',
  templateUrl: './validation-button.component.html',
  styleUrls: ['./validation-button.component.scss']
})
export class ValidationButtonComponent implements OnInit {
  dialogData: any;
  iconPrefix: SafeHtml = '';
  ready = false;

  recrute: Recrute = null;
  recruteForm: RecruteFormModel = null;
  datePriseFonction = null;
  stateTransitionToGo = TransitionEnum;
  constructor(@Inject(MAT_DIALOG_DATA) public data: DataTransitionValidationModel,
              public dialogRef: MatDialogRef<ValidationButtonComponent>,
              public dateSvc: DateHelperService,
              public dossiersSvc: DarDossiersService) {
    console.log(data.dossier);
    if (data && data.recrute) {
      this.recruteForm = <RecruteFormModel>{
        recrute: data.recrute.recrute,
        gestionnaire: data.recrute.gestionnaire,
        datePriseFonction: null,
        INMRecrutement: null,
        hasINMRecrutement: data.recrute.hasINMrecrutement
      };

      this.dialogData = data.recrute;

      let icon = '';
      switch (this.dialogData.iconType) {
        case 'warning':
          icon = '<i class="material-icons">warning</i>';
          break;
        case 'info':
          icon = '<i class="material-icons">info</i>';
          break;
        case 'error':
          icon = '<i class="material-icons">error</i>';
          break;
      }
      this.iconPrefix = icon;
    }
  }

  ngOnInit() {
    setTimeout(() => this.ready = true, 0);
  }

  onChangeRecrut(data: RecruteFormModel) {
    this.recruteForm = data;
  }
  titlePath() {
    const _prefix = `${this.dialogData.title}`;
    return [_prefix, `${this.dossiersSvc.toStateLabel(this.data.transition)}`];
  }
  /**
   * La date de prise de fonction est obligatoire
   * L'INM recrutement est obligatoire
   */
  saveIsDisabled() {
    if (this.dialogData.hasINMrecrutement && (this.recruteForm?.INMRecrutement ?? 0)  <= 0) {
      return true;
    }
    return this.dialogData.hasDatePriseFonction && !this.datePriseFonction;
  }
  validate() {
    if (this.dialogRef) {
      let hasRecrute = false;
      let hasDate = false;
      let hasINM = false;
      if (this.recruteForm?.recrute &&
        ((this.recruteForm.recrute.first_name || this.recruteForm.recrute.last_name))) {
        hasRecrute = true;
      }
      if (this.recruteForm?.INMRecrutement) {
        hasINM = true;
      }
      if (this.recruteForm && this.recruteForm.gestionnaire) {
        hasRecrute = true;
      }

      if (this.dialogData.hasDatePriseFonction && this.datePriseFonction) {
        hasDate = true;
      }

      const data: RecruteValidationDataModel = {
        hasRecrute: hasRecrute,
        hasINM: hasINM,
        hasDate: hasDate,
        recrute: this.recruteForm,
        datePriseFonction: this.datePriseFonction
      };

      this.dialogRef.close(data);
    }
  }
}
